import cms from 'apis/cms';
// import { objFake } from './objFake';
import { CustomTagProps } from 'types/CustomTagProps';
import { showToast } from 'utils/showToast';

export async function saveTag(newTag: CustomTagProps, toast: any, t: any) {
  let isSuccess = false;
  const payload: any = structuredClone(newTag);
  delete payload.id;
  delete payload.created_at;
  delete payload.updated_at;
  delete payload.file;

  await cms.rest
    .post(`promotional-tags`, payload)
    .then(() => {
      showToast(
        toast,
        'customTags.success',
        'customTags.successSaveTag',
        'success',
        t,
      );
      isSuccess = true;
    })
    .catch(() => {
      isSuccess = false;
      showToast(
        toast,
        'customTags.erro',
        'customTags.errorSaveTag',
        'error',
        t,
      );
    });

  return isSuccess;
}

export async function editTag(
  newTag: CustomTagProps,
  id: string,
  toast: any,
  t: any,
) {
  let isSuccess = false;
  const payload: any = structuredClone(newTag);
  delete payload.id;
  // delete payload.created_at;
  // delete payload.updated_at;
  delete payload.file;

  await cms.rest
    .patch(`promotional-tags/${id}`, payload)
    .then(() => {
      isSuccess = true;
      showToast(
        toast,
        'customTags.success',
        'customTags.successEditTag',
        'success',
        t,
      );
    })
    .catch(() => {
      isSuccess = false;
      showToast(
        toast,
        'customTags.erro',
        'customTags.errorEditTag',
        'error',
        t,
      );
    });

  return isSuccess;
}
